import { I18N_KEYS } from "common/i18n/keys";

export const CONFIRM_MODAL_PRESET = {
  default: {
    confirm: I18N_KEYS.common.button.confirm,
    cancel: I18N_KEYS.common.button.cancel,
  },
  leave: {
    confirm: I18N_KEYS.common.button.leave,
    cancel: I18N_KEYS.common.button.cancel,
  },
  delete: {
    confirm: I18N_KEYS.common.button.delete,
    cancel: I18N_KEYS.common.button.cancel,
  },
  continue: {
    confirm: I18N_KEYS.common.button.continue,
    cancel: I18N_KEYS.common.button.cancel,
  },
};
